import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";

import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {
  ESeverity,
  IInputTextOptions,
  InputTextComponent,
  IToastService,
  toastServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { IApplicationsOverviewModalForm } from "../../i-applications-overview-modal.service";
import { IReceiver } from "../../../../models/i-receiver";
import { receiverRestClientInjectionToken } from "../../../../rest-clients/receiver/receiver-rest-client-injection-token";
import { IReceiverRestClient } from "../../../../rest-clients/receiver/i-receiver-rest.client";
import { IUpdateReceiverForm } from "../../../../rest-clients/receiver/forms/i-update-receiver-form";

@Component({
  selector: "app-system-tab",
  templateUrl: "./system-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    InputTextComponent
]
})
export class SystemTabComponent {
  public readonly formGroup: FormGroup;
  public readonly nameInputTextOptions: IInputTextOptions;
  private readonly _receiver: IReceiver | null;
  private readonly _cloudId: string | null;
  private readonly _groupId: string | null;

  constructor(@Inject(toastServiceInjectionToken) private readonly _toastService: IToastService,
              @Inject(receiverRestClientInjectionToken) private readonly _receiverRestClient: IReceiverRestClient,
              private readonly _dynamicDialogConfig: DynamicDialogConfig<IApplicationsOverviewModalForm>) {
    this._receiver = this._dynamicDialogConfig.data?.receiver ?? null;
    this._cloudId = this._dynamicDialogConfig.data?.cloudId ?? null;
    this._groupId = this._dynamicDialogConfig.data?.groupId ?? null;

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(this._receiver?.name ?? "", {
        validators: [Validators.required]
      })
    }, {
      updateOn: "submit"
    });

    this.nameInputTextOptions = {
      title: "Name",
      inputId: "receiver-name",
      placeholder: "Name",
      required: true,
      formControlEntry: {
        formControl: this.formGroup.get("name")! as FormControl<string>,
        key: "receiver-name"
      }
    };
  }

  public submit(event: Event): void {
    event.preventDefault();

    if (!this.formGroup.valid || this._receiver === null || this._cloudId === null || this._groupId === null) {
      return;
    }

    const updateReceiverForm: IUpdateReceiverForm = {
      cloudId: this._cloudId,
      groupId: this._groupId,
      receiverId: this._receiver.id,
      name: this.formGroup.get("name")?.value
    };

    this._receiverRestClient.updateReceiver(updateReceiverForm).then(() => {
      this._toastService.setMessage({
        title: "Erfolgreich",
        detail: "Receiver wurde erfolgreich aktualisiert",
        severity: ESeverity.success
      });
      this._dynamicDialogConfig.data?.onSaveCallback?.();
    }).catch(() => {
      this._toastService.setMessage({
        title: "Fehler",
        detail: "Receiver konnte nicht aktualisiert werden",
        severity: ESeverity.error
      });
    });
  }
}
